import { IComposableChartsWidget } from 'wisestep-api';

import { clientsDashboardKeysObjectList } from '../BaseCharts/clientListing/helper/clientDetailsDashboardKeys';
import { leadDashboardKeysObjectList } from '../BaseCharts/lead/leadDashboardKeys';
import {
  postgreApplicationDashboardKeysObjectList,
  postgreClientNotesDashboardKeysObjectList,
} from '../DerivedCharts';
import { postgreCallsDashboardKeysObjectList } from '../DerivedCharts/Calls/helper/postgresCallsDashboardKeys';
import { postgreCvUploadDashboardKeysList } from '../DerivedCharts/cvUpload/helper/postgreCvUploadDashboardsKeys';
import { postgreCvViewDashboardKeysList } from '../DerivedCharts/cvView/helper/postgreCvViewDashboardKeys';
import { postgreEmailsDashboardKeysObjectList } from '../DerivedCharts/emails/helper/postgresEmailsDashboardKeys';
import { postgresFollowUpDashboardKeysObjectList } from '../DerivedCharts/followUps/helper/postgresFollowUpDashboardKeys';
import { postgreJobsDashboardKeysObjectList } from '../DerivedCharts/Jobs/helper/postgreJobsDashboardKeys';
import { postgreMappingsDashboardKeysObjectList } from '../DerivedCharts/mappings/helper/postgreMappingsDashboardKeys';
import { potentialRevenueDashboardKeysObjectList } from '../DerivedCharts/PotentialRevenue/helper/potentialRevenueDashboardkeys';
import { postgresRTRAnalyticsDashboardKeysObjectList } from '../DerivedCharts/rtr/helper/postgresRTRAnalyticsDashboardKeys';
import { postgreSmsDashboardKeysObjectList } from '../DerivedCharts/sms/helper/postgreSmsDashboardKeys';
import { postgreSubmissionsDashboardKeysObjectList } from '../DerivedCharts/submissions/helper/postgreSubmissionDashboardKeys';
import { freeTextWidgetKeys } from '../Widgets/helper/freeTextWidgetKeys';

//Add your composable widgets list here - will be used to render your options
const composableChartsDrawerKeys: Record<string, IComposableChartsWidget[]> = {
  jobs: postgreJobsDashboardKeysObjectList,
  sms: postgreSmsDashboardKeysObjectList,
  calls: postgreCallsDashboardKeysObjectList,
  cvView: postgreCvViewDashboardKeysList,
  submissions: postgreSubmissionsDashboardKeysObjectList,
  clients: clientsDashboardKeysObjectList,
  client_notes: postgreClientNotesDashboardKeysObjectList,
  mappings: postgreMappingsDashboardKeysObjectList,
  revenue: potentialRevenueDashboardKeysObjectList,
  emails: postgreEmailsDashboardKeysObjectList,
  cvUpload: postgreCvUploadDashboardKeysList,
  pipeline: [],
  application_received: postgreApplicationDashboardKeysObjectList,
  followUps: postgresFollowUpDashboardKeysObjectList,
  freeTextWidget: freeTextWidgetKeys,
  lead: leadDashboardKeysObjectList,
  rtr: postgresRTRAnalyticsDashboardKeysObjectList,
};

//This will be used to render the specific chart
export const composableChartsDrawerValues: IComposableChartsWidget[] = [
  ...composableChartsDrawerKeys.jobs,
  ...composableChartsDrawerKeys.sms,
  ...composableChartsDrawerKeys.calls,
  ...composableChartsDrawerKeys.cvView,
  ...composableChartsDrawerKeys.submissions,
  ...composableChartsDrawerKeys.mappings,
  ...clientsDashboardKeysObjectList,
  ...composableChartsDrawerKeys.client_notes,
  ...composableChartsDrawerKeys.revenue,
  ...composableChartsDrawerKeys.emails,
  ...composableChartsDrawerKeys.cvUpload,
  ...composableChartsDrawerKeys.pipeline,
  ...composableChartsDrawerKeys.application_received,
  ...composableChartsDrawerKeys.followUps,
  ...composableChartsDrawerKeys.freeTextWidget,
  ...composableChartsDrawerKeys.lead,
  ...composableChartsDrawerKeys.rtr,
];

export default composableChartsDrawerKeys;
